import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import PageConPc from '@/components/PowerOcean/Collection';
import PageConPc_DE from '@/components/PowerOcean/Collection/VersionDE';
import PageConH5 from '@/componentsH5/PowerOcean/Collection';
import PageConH5_DE from '@/componentsH5/PowerOcean/Collection/VersionDE';
import SEOlinksA from '@/components/SEOlinksA';
import ProductNav from '@/components/ProductCommon/ProductNav';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';

// 产品详情页参数
const productName = 'home-battery/PowerOcean';
const generalKey = 'product_smart_js_s1';

export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useRouter, useState, useEffect, useLang, gtm } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('solarspeicher');
    const PageCon = isMobile ? (locale === 'de' ? PageConH5_DE : PageConH5) : locale === 'de' ? PageConPc_DE : PageConPc;
    const [theme, setTheme] = useState('white');
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
    };

    useEffect(() => {
        if (!['de'].includes(locale)) {
            router.push('/404');
        }
    }, [locale, router]);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['de']} locale={locale} pathname={'solarspeicher'} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={'Solarspeicher'}
                    theme={'white'}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                    showQuote={true}
                    showBlog={false}
                    langKey="solarspeicher"
                    callbackQuote={() => {
                        const target = document.querySelector('.power-ocean-collection-N') as HTMLElement;
                        if (target) {
                            window.scrollTo({
                                top: target?.offsetTop - 80,
                                behavior: 'smooth',
                            });
                        }
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'solution_button',
                            list_name: t('secA_title'),
                            button_name: t('secA_btn'),
                        });
                        locale === 'de' && window?.lintrk('track', { conversion_id: 14324402 });
                    }}
                />
                <PageCon langKey={'solarspeicher'} />
            </PageLayout>
        </>
    );
}
